(function() { module.exports = window["Next"]["Message"]; }());